/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import theme, { Content_Text } from "../Component/theme";

import img_Platform_1 from "../image/image_Platform_1.png";
import img_Platform_10 from "../image/image_Platform_10.png";
import img_Platform_10_sel from "../image/image_Platform_10_sel.png";
import img_Platform_11 from "../image/image_Platform_11.png";
import img_Platform_11_sel from "../image/image_Platform_11_sel.png";
import img_Platform_1_sel from "../image/image_Platform_1_sel.png";
import img_Platform_2 from "../image/image_Platform_2.png";
import img_Platform_2_sel from "../image/image_Platform_2_sel.png";
import img_Platform_3 from "../image/image_Platform_3.png";
import img_Platform_3_sel from "../image/image_Platform_3_sel.png";
import img_Platform_4 from "../image/image_Platform_4.png";
import img_Platform_4_sel from "../image/image_Platform_4_sel.png";
import img_Platform_5 from "../image/image_Platform_5.png";
import img_Platform_5_sel from "../image/image_Platform_5_sel.png";
import img_Platform_6 from "../image/image_Platform_6.png";
import img_Platform_6_sel from "../image/image_Platform_6_sel.png";
import img_Platform_7 from "../image/image_Platform_7.png";
import img_Platform_7_sel from "../image/image_Platform_7_sel.png";
import img_Platform_8 from "../image/image_Platform_8.png";
import img_Platform_8_sel from "../image/image_Platform_8_sel.png";
import img_Platform_9 from "../image/image_Platform_9.png";
import img_Platform_9_sel from "../image/image_Platform_9_sel.png";

import img_page1 from "../image/img_page1.png";
import img_page10 from "../image/img_page10.png";
import img_page2 from "../image/img_page2.png";
import img_page3 from "../image/img_page3.png";
import img_page5_1 from "../image/img_page5_1.png";
import img_page5_2 from "../image/img_page5_2.png";
import img_page6 from "../image/img_page6.png";
import img_page7 from "../image/img_page7.png";
import img_page9_1 from "../image/img_page9_1.png";
import image_관리대장 from "../image/관리대장.webp";
import image_관리대장민원 from "../image/관리대장민원.webp";
import image_관리대장유형 from "../image/관리대장유형.webp";
import image_시설관리 from "../image/시설관리.webp";
import image_일정관리 from "../image/일정관리.webp";
import image_출퇴근관리 from "../image/출퇴근관리.webp";

const Main_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 20px;
`;

const Main_Content4 = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;

const Select_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 1100px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 1200px) {
    padding: 50px 15px 0px 15px;
    max-width: 650px;
  }
  @media (max-width: 800px) {
    padding: 0px;
    max-width: 650px;
  }
`;
const Select_div2 = styled.div`
  display: flex;
  width: 100%;
  max-width: 1100px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 1200px) {
    padding: 0px 15px 0px 15px;
    max-width: 500px;
  }
`;

const Btn_Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  text-align: center;
  @media (max-width: 800px) {
    flex: 0;
  }
`;

const Main_Bar = styled.div`
  border-width: 2px 0px 0px 0px;
  border-color: ${theme.colors.bgGray};
  border-style: solid;
  width: 1200px;
  margin-bottom: 30px;
  @media (max-width: 800px) {
    width: 100%;
  }
`;

const Title_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: 5px;
`;
const Image_div2 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
const Text_div2 = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  text-align: center;
  margin-bottom: 100px;
`;

const Image3 = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: ${(props) => (props.$large ? "900px" : "800px")};
  margin-bottom: 30px;
  margin-left: ${(props) => (props.$large ? "100px" : 0)};
  border-radius: 8px;

  @media (max-width: 800px) {
    width: ${(props) => (props.$large ? "90%" : "80%")};
    margin-left: ${(props) => (props.$large ? "10%" : 0)};
  }
`;

const Image2 = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: 60px;
  cursor: pointer;
`;

const Platform_FMS_드라이브형 = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [sel, set_Sel] = useState("01");

  useEffect(() => {
    // 사이즈 체크
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {windowSize.width > 1200 ? (
        <Main_div>
          <Select_div>
            <Main_Content4>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("01");
                  }}
                  src={sel === "01" ? img_Platform_1_sel : img_Platform_1}
                  alt={img_Platform_1}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "01"}
                  $lightGray
                  $small
                  $bold
                >
                  계정관리
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("02");
                  }}
                  src={sel === "02" ? img_Platform_2_sel : img_Platform_2}
                  alt={img_Platform_1}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "02"}
                  $lightGray
                  $small
                  $bold
                >
                  건축물 현황
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("03");
                  }}
                  src={sel === "03" ? img_Platform_3_sel : img_Platform_3}
                  alt={img_Platform_1}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "03"}
                  $lightGray
                  $small
                  $bold
                >
                  보고서 관리
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("04");
                  }}
                  src={sel === "04" ? img_Platform_4_sel : img_Platform_4}
                  alt={img_Platform_1}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "04"}
                  $lightGray
                  $small
                  $bold
                >
                  관리대장
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("05");
                  }}
                  src={sel === "05" ? img_Platform_5_sel : img_Platform_5}
                  alt={img_Platform_1}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "05"}
                  $lightGray
                  $small
                  $bold
                >
                  보수비 및
                </Content_Text>
                <Content_Text $blue2={sel === "05"} $lightGray $small $bold>
                  집행실적
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("06");
                  }}
                  src={sel === "06" ? img_Platform_6_sel : img_Platform_6}
                  alt={img_Platform_1}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "06"}
                  $lightGray
                  $small
                  $bold
                >
                  운영계획서
                </Content_Text>
              </Btn_Div>

              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("07");
                  }}
                  src={sel === "07" ? img_Platform_7_sel : img_Platform_7}
                  alt={img_Platform_1}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "07"}
                  $lightGray
                  $small
                  $bold
                >
                  특별 및
                </Content_Text>
                <Content_Text $blue2={sel === "07"} $lightGray $small $bold>
                  정기점검
                </Content_Text>
              </Btn_Div>

              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("08");
                  }}
                  src={sel === "08" ? img_Platform_8_sel : img_Platform_8}
                  alt={img_Platform_1}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "08"}
                  $lightGray
                  $small
                  $bold
                >
                  시설관리
                </Content_Text>
              </Btn_Div>

              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("09");
                  }}
                  src={sel === "09" ? img_Platform_9_sel : img_Platform_9}
                  alt={img_Platform_1}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "09"}
                  $lightGray
                  $small
                  $bold
                >
                  교육 및
                </Content_Text>
                <Content_Text $blue2={sel === "09"} $lightGray $small $bold>
                  직원관리
                </Content_Text>
              </Btn_Div>

              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("10");
                  }}
                  src={sel === "10" ? img_Platform_10_sel : img_Platform_10}
                  alt={img_Platform_1}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "10"}
                  $lightGray
                  $small
                  $bold
                >
                  보험증권
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("11");
                  }}
                  src={sel === "11" ? img_Platform_11_sel : img_Platform_11}
                  alt={img_Platform_1}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "11"}
                  $lightGray
                  $small
                  $bold
                >
                  일정관리
                </Content_Text>
              </Btn_Div>
            </Main_Content4>
          </Select_div>
        </Main_div>
      ) : windowSize.width > 800 ? (
        <>
          <Main_div>
            <Select_div>
              <Main_Content4>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("01");
                    }}
                    src={sel === "01" ? img_Platform_1_sel : img_Platform_1}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "01"}
                    $lightGray
                    $small
                    $bold
                  >
                    계정관리
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("02");
                    }}
                    src={sel === "02" ? img_Platform_2_sel : img_Platform_2}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "02"}
                    $lightGray
                    $small
                    $bold
                  >
                    건축물 현황
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("03");
                    }}
                    src={sel === "03" ? img_Platform_3_sel : img_Platform_3}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "03"}
                    $lightGray
                    $small
                    $bold
                  >
                    보고서 관리
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("04");
                    }}
                    src={sel === "04" ? img_Platform_4_sel : img_Platform_4}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "04"}
                    $lightGray
                    $small
                    $bold
                  >
                    관리대장
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("05");
                    }}
                    src={sel === "05" ? img_Platform_5_sel : img_Platform_5}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "05"}
                    $lightGray
                    $small
                    $bold
                  >
                    보수비 및
                  </Content_Text>
                  <Content_Text $blue2={sel === "05"} $lightGray $small $bold>
                    집행실적
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("06");
                    }}
                    src={sel === "06" ? img_Platform_6_sel : img_Platform_6}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "06"}
                    $lightGray
                    $small
                    $bold
                  >
                    운영계획서
                  </Content_Text>
                </Btn_Div>
              </Main_Content4>
            </Select_div>
          </Main_div>
          <Main_div>
            <Select_div2>
              <Main_Content4>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("07");
                    }}
                    src={sel === "07" ? img_Platform_7_sel : img_Platform_7}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "07"}
                    $lightGray
                    $small
                    $bold
                  >
                    특별 및
                  </Content_Text>
                  <Content_Text $blue2={sel === "07"} $lightGray $small $bold>
                    정기점검
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("08");
                    }}
                    src={sel === "08" ? img_Platform_8_sel : img_Platform_8}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "08"}
                    $lightGray
                    $small
                    $bold
                  >
                    시설관리
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("09");
                    }}
                    src={sel === "09" ? img_Platform_9_sel : img_Platform_9}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "09"}
                    $lightGray
                    $small
                    $bold
                  >
                    교육 및
                  </Content_Text>
                  <Content_Text $blue2={sel === "09"} $lightGray $small $bold>
                    직원관리
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("10");
                    }}
                    src={sel === "10" ? img_Platform_10_sel : img_Platform_10}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "10"}
                    $lightGray
                    $small
                    $bold
                  >
                    보험증권
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("11");
                    }}
                    src={sel === "11" ? img_Platform_11_sel : img_Platform_11}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "11"}
                    $lightGray
                    $small
                    $bold
                  >
                    일정관리
                  </Content_Text>
                </Btn_Div>
              </Main_Content4>
            </Select_div2>
          </Main_div>
        </>
      ) : (
        <>
          <Main_div>
            <Select_div>
              <Main_Content4>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("01");
                    }}
                    src={sel === "01" ? img_Platform_1_sel : img_Platform_1}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "01"}
                    $lightGray
                    $small
                    $bold
                  >
                    계정관리
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("02");
                    }}
                    src={sel === "02" ? img_Platform_2_sel : img_Platform_2}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "02"}
                    $lightGray
                    $small
                    $bold
                  >
                    건축물 현황
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("03");
                    }}
                    src={sel === "03" ? img_Platform_3_sel : img_Platform_3}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "03"}
                    $lightGray
                    $small
                    $bold
                  >
                    보고서 관리
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("04");
                    }}
                    src={sel === "04" ? img_Platform_4_sel : img_Platform_4}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "04"}
                    $lightGray
                    $small
                    $bold
                  >
                    관리대장
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("05");
                    }}
                    src={sel === "05" ? img_Platform_5_sel : img_Platform_5}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "05"}
                    $lightGray
                    $small
                    $bold
                  >
                    보수비 및
                  </Content_Text>
                  <Content_Text $blue2={sel === "05"} $lightGray $small $bold>
                    집행실적
                  </Content_Text>
                </Btn_Div>
              </Main_Content4>
            </Select_div>
          </Main_div>
          <Main_div>
            <Select_div>
              <Main_Content4>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("06");
                    }}
                    src={sel === "06" ? img_Platform_6_sel : img_Platform_6}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "06"}
                    $lightGray
                    $small
                    $bold
                  >
                    운영계획서
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("07");
                    }}
                    src={sel === "07" ? img_Platform_7_sel : img_Platform_7}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "07"}
                    $lightGray
                    $small
                    $bold
                  >
                    특별 및
                  </Content_Text>
                  <Content_Text $blue2={sel === "07"} $lightGray $small $bold>
                    정기점검
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("08");
                    }}
                    src={sel === "08" ? img_Platform_8_sel : img_Platform_8}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "08"}
                    $lightGray
                    $small
                    $bold
                  >
                    시설관리
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("09");
                    }}
                    src={sel === "09" ? img_Platform_9_sel : img_Platform_9}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "09"}
                    $lightGray
                    $small
                    $bold
                  >
                    교육 및
                  </Content_Text>
                  <Content_Text $blue2={sel === "09"} $lightGray $small $bold>
                    직원관리
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("10");
                    }}
                    src={sel === "10" ? img_Platform_10_sel : img_Platform_10}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "10"}
                    $lightGray
                    $small
                    $bold
                  >
                    보험증권
                  </Content_Text>
                </Btn_Div>
              </Main_Content4>
            </Select_div>
          </Main_div>
          <Main_div>
            <Select_div>
              <Main_Content4 style={{ justifyContent: "flex-start" }}>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("11");
                    }}
                    src={sel === "11" ? img_Platform_11_sel : img_Platform_11}
                    alt={img_Platform_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "11"}
                    $lightGray
                    $small
                    $bold
                  >
                    일정관리
                  </Content_Text>
                </Btn_Div>
              </Main_Content4>
            </Select_div>
          </Main_div>
        </>
      )}
      <Main_div>
        <Main_Bar></Main_Bar>
      </Main_div>
      <Title_div>
        <Content_Text $bold $blue2>
          {sel}
        </Content_Text>
      </Title_div>
      <Title_div style={{ marginBottom: 30 }}>
        <Content_Text $xlarge $xbold>
          {sel === "01"
            ? "계정관리"
            : sel === "02"
            ? "건축물 현황"
            : sel === "03"
            ? "보고서 관리"
            : sel === "04"
            ? "관리대장"
            : sel === "05"
            ? "보수비 및 집행실적"
            : sel === "06"
            ? "운영계획서"
            : sel === "07"
            ? "특별,정기점검"
            : sel === "08"
            ? "시설관리"
            : sel === "09"
            ? "교육 및 직원관리"
            : sel === "10"
            ? "보험증권"
            : "일정관리"}
        </Content_Text>
      </Title_div>
      {sel === "01" ? (
        <>
          <Image_div2>
            <Image3 src={img_page1} alt={img_page1} />
          </Image_div2>
          <Text_div2>
            <Content_Text $gray>
              여러 현장의 계정을 관리할 수 있습니다.
            </Content_Text>
          </Text_div2>
        </>
      ) : sel === "02" ? (
        <>
          <Image_div2>
            <Image3 src={img_page2} alt={img_page2} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              도면관리, 내역서 관리
            </Content_Text>
            <Content_Text $gray>
              드라이브 형식으로 파일 업로드와 내부 폴더 관리를 할 수 있습니다.
            </Content_Text>
          </Text_div2>
        </>
      ) : sel === "03" ? (
        <>
          <Image_div2>
            <Image3 src={img_page3} alt={img_page3} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              월말보고서, 분기보고서
            </Content_Text>
            <Content_Text $gray>
              드라이브 형식으로 파일 업로드와 내부 폴더 관리를 할 수 있습니다.
            </Content_Text>
          </Text_div2>
        </>
      ) : sel === "04" ? (
        <>
          <Image_div2>
            <Image3 src={image_관리대장} alt={image_관리대장} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              냉난방기, 보일러, 타일, 펌프 관리
            </Content_Text>
            <Content_Text $gray>
              관리할 시설을 등록하고 자료 관리 및 다운로드가 가능합니다.
            </Content_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={image_관리대장민원} alt={image_관리대장민원} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              민원
            </Content_Text>
            <Content_Text $gray>
              민원을 등록하고 관리 및 자료 출력이 가능합니다.
            </Content_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={image_관리대장유형} alt={image_관리대장유형} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              유형자산
            </Content_Text>
            <Content_Text $gray>
              유형자산을 등록하고 관리 및 자료 다운로드가 가능합니다.
            </Content_Text>
          </Text_div2>
        </>
      ) : sel === "05" ? (
        <>
          <Image_div2>
            <Image3 src={img_page5_1} alt={img_page5_1} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              일상수선비, 장기수선충당금
            </Content_Text>
            <Content_Text $gray>
              드라이브 형식으로 파일 업로드와 내부 폴더 관리를 할 수 있습니다.
            </Content_Text>
          </Text_div2>
          <Image_div2>
            <Image3 $large src={img_page5_2} alt={img_page5_2} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              업체관리
            </Content_Text>
            <Content_Text $gray>
              업체를 등록하고 관리할 수 있습니다.
            </Content_Text>
          </Text_div2>
        </>
      ) : sel === "06" ? (
        <>
          <Image_div2>
            <Image3 src={img_page6} alt={img_page6} />
          </Image_div2>
          <Text_div2>
            <Content_Text $gray>
              드라이브 형식으로 파일 업로드와 내부 폴더 관리를 할 수 있습니다.
            </Content_Text>
          </Text_div2>
        </>
      ) : sel === "07" ? (
        <>
          <Image_div2>
            <Image3 src={img_page7} alt={img_page7} />
          </Image_div2>
          <Text_div2>
            <Content_Text $gray>
              드라이브 형식으로 파일 업로드와 내부 폴더 관리를 할 수 있습니다.
            </Content_Text>
          </Text_div2>
        </>
      ) : sel === "08" ? (
        <>
          <Image_div2>
            <Image3 src={image_시설관리} alt={image_시설관리} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              점검일지
            </Content_Text>
            <Content_Text $gray>
              시설 관련 점검일지, 근무일지 등 점검사항을 등록하고 관리할 수
              있습니다.
            </Content_Text>
          </Text_div2>
        </>
      ) : sel === "09" ? (
        <>
          <Image_div2>
            <Image3 src={img_page9_1} alt={img_page9_1} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              교육일지, 자격관리
            </Content_Text>
            <Content_Text $gray>
              드라이브 형식으로 파일 업로드와 내부 폴더 관리를 할 수 있습니다.
            </Content_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={image_출퇴근관리} alt={image_출퇴근관리} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              출퇴근관리
            </Content_Text>
            <Content_Text $gray>출퇴근 관리를 할 수 있습니다.</Content_Text>
          </Text_div2>
        </>
      ) : sel === "10" ? (
        <>
          <Image_div2>
            <Image3 src={img_page10} alt={img_page10} />
          </Image_div2>
          <Text_div2>
            <Content_Text $gray>
              드라이브 형식으로 파일 업로드와 내부 폴더 관리를 할 수 있습니다.
            </Content_Text>
          </Text_div2>
        </>
      ) : (
        <>
          <Image_div2>
            <Image3 src={image_일정관리} alt={image_일정관리} />
          </Image_div2>
          <Text_div2>
            <Content_Text $gray>
              드라이브 형식으로 파일 업로드와 내부 폴더 관리를 할 수 있습니다.
            </Content_Text>
          </Text_div2>
        </>
      )}
    </>
  );
};

export default Platform_FMS_드라이브형;
